import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import { idxMap } from 'helpers/styleMapIdx';

import styles from './FormControl.module.scss';

const VARIANTS = {
  vertical: styles.controlVertical,
  horizontal: styles.controlHorizontal,
};

const FormControl = ({
  className,
  children,
  required,
  withVerticalSpace,
  haveError,
  error,
  variant,
  label,
  labelProps,
}: {
  className: any;
  children: any;
  required: any;
  withVerticalSpace: any;
  haveError: any;
  error: any;
  variant: any;
  label: any;
  labelProps: any;
}) => (
  <div
    className={cn(
      styles.control,
      { [styles.controlWithSpace]: withVerticalSpace },
      idxMap(VARIANTS as Record<string, string>, variant),
      className,
    )}
  >
    {label && (
      <Typography
        className={cn(styles.label, { [styles.labelRequired]: required })}
        variant="body3"
        weight="medium"
        mode="compact"
        {...labelProps}
      >
        {label}
      </Typography>
    )}
    {children}
    {haveError && error && (
      <div className={styles.error}>
        <Typography className={styles.errorText} variant="caption">
          {error}
        </Typography>
      </div>
    )}
  </div>
);

FormControl.defaultProps = {
  variant: 'vertical',
  withVerticalSpace: true,
};

export default React.memo(FormControl) as any;
